import './App.css';
import Card from './components/Info';
import React from 'react';


function App() {
  return (
    <div className="App">
      <Card/>
    </div>
  );
}

export default App;
